<template>
    <svg height="18.494" viewBox="0 0 18.494 18.494" width="18.494" xmlns="http://www.w3.org/2000/svg">
        <g id="Icon_feather-settings" data-name="Icon feather-settings" transform="translate(0.85 0.85)">
            <path
                id="Path_517"
                d="M18.08,15.79a2.29,2.29,0,1,1-2.29-2.29A2.29,2.29,0,0,1,18.08,15.79Z"
                data-name="Path 517"
                fill="none"
                stroke="#3699ff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.7"
                transform="translate(-7.393 -7.393)"
            />
            <path
                id="Path_518"
                d="M15.546,12.187a1.26,1.26,0,0,0,.252,1.389l.046.046a1.528,1.528,0,1,1-2.16,2.16l-.046-.046a1.27,1.27,0,0,0-2.153.9v.13a1.527,1.527,0,0,1-3.053,0V16.7a1.26,1.26,0,0,0-.824-1.153,1.26,1.26,0,0,0-1.389.252l-.046.046a1.528,1.528,0,1,1-2.16-2.16l.046-.046a1.27,1.27,0,0,0-.9-2.153h-.13a1.527,1.527,0,1,1,0-3.053H3.1a1.26,1.26,0,0,0,1.153-.824A1.26,1.26,0,0,0,4,6.217L3.95,6.172a1.528,1.528,0,1,1,2.16-2.16l.046.046a1.26,1.26,0,0,0,1.389.252h.061A1.26,1.26,0,0,0,8.37,3.156v-.13a1.527,1.527,0,0,1,3.053,0V3.1a1.27,1.27,0,0,0,2.153.9l.046-.046a1.528,1.528,0,1,1,2.16,2.16l-.046.046a1.26,1.26,0,0,0-.252,1.389v.061a1.26,1.26,0,0,0,1.153.763h.13a1.527,1.527,0,1,1,0,3.053H16.7a1.26,1.26,0,0,0-1.153.763Z"
                data-name="Path 518"
                fill="none"
                stroke="#3699ff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.7"
                transform="translate(-1.5 -1.5)"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "Settings",
};
</script>
